import { useCallback } from 'react';
import { CareCreditMethodCard, careCreditMethodCards } from '../../../components/care-credit-method-card';
import { useCareCreditSmsNumber } from '../../../hooks/use-care-credit-person-sms-number';
import { useCareCreditTranslations } from '../../../hooks/use-care-credit-translations';
import { EnrollmentBaseStep } from '../atoms/step/enrollment-base-step';
import { useCareCreditEnrollmentContext } from '../context/care-credit-enrollment.context';
import { CareCreditEnrollmentMultiSteps } from '../enrollment-multi-step.types';

const CURRENT_STEP: CareCreditEnrollmentMultiSteps = 'select-process-method';
const FORM_STEP: CareCreditEnrollmentMultiSteps = 'new-application-form';

export const Step1SelectProcessMethod = () => {
  const { t } = useCareCreditTranslations();

  const {
    person,
    locationId,
    invoice,
    onGoBack,
    onGoToMessageStep,
    multiStep: { goToStep },
  } = useCareCreditEnrollmentContext();

  const { firstValidPhoneNumber } = useCareCreditSmsNumber({
    person,
    locationId,
  });

  const onSelectInOffice = useCallback(() => {
    goToStep({ orStep: FORM_STEP });
  }, [goToStep]);

  return (
    <EnrollmentBaseStep
      id={CURRENT_STEP}
      label={t('How would you like to check for the CareCredit Prequalification?')}
      footer={{
        primary: null,
        secondary: null,
        back: {
          children: t('Back'),
          iconName: 'back',
        },
        onClickBack: onGoBack,

        /**
         * This step might be reached from the payments panel, where there is no invoice.
         * In which case, hide the back button, as there's no "payment methods" step to go back to.
         */
        showBackButton: !!invoice,
      }}
    >
      <div className={careCreditMethodCards}>
        <CareCreditMethodCard iconName='forms' label={t('Submit In-Office')} onClick={onSelectInOffice} />
        <CareCreditMethodCard
          iconName='message'
          label={t('Text Link to Customer')}
          onClick={onGoToMessageStep}
          disabled={!firstValidPhoneNumber}
          disabledTooltip={!firstValidPhoneNumber ? t('No valid phone number') : undefined}
        />
      </div>
    </EnrollmentBaseStep>
  );
};
